
const DropdownItem = ({ children, onClick, className = '' }: {
  children: React.ReactNode,
  onClick?: () => void,
  className?: string
}) => (
  <div
    className={`px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer ${className}`}
    onClick={onClick}
  >
    {children}
  </div>
);

export default DropdownItem